export const filterDataAttributes = props => {
  return Object.keys(props).filter(key => key.startsWith("data-")).reduce((accumulator, key) => {
    accumulator[key] = props[key];
    return accumulator;
  }, {});
};